import { createSlice, createAction, PayloadAction } from '@reduxjs/toolkit';

import { ISelectOption } from '@crm-framework/form-fields';

import {
  INotificationsState,
  NotificationsSetUnreadMessagesAction,
  NotificationsSetEventTypeAction,
  NotificationsSetNotificationTypesAction,
  NotificationsSetSelectedIdsAction,
  NotificationsSetIsLoadingAction,
  INotificationsMarkAsReadActionPayload,
  INotificationsDeleteActionPayload,
  INotificationsNewReceivedActionPayload,
} from './types';
import { NOTIFICATION_TYPE_ALL } from './consts';

const initialState: INotificationsState = {
  isReady: false,
  isLoading: false,
  unreadMessages: 0,
  eventType: NOTIFICATION_TYPE_ALL,
  notificationTypes: [],
  selectedIds: [],
  userBusinessUnits: [],
  buFilterValue: [],
  isBUFilterDisabled: false,
};

const STORE_NAME = '@notifications';

// TODO Action payload shouldn't be object if possible
const NotificationsStore = createSlice({
  name: STORE_NAME,
  initialState,
  reducers: {
    finishInit: (state) => {
      state.isReady = true;
    },
    setUnreadMessages: (
      state,
      action: NotificationsSetUnreadMessagesAction
    ) => {
      state.unreadMessages = action.payload.unreadMessages;
    },
    setEventType: (state, action: NotificationsSetEventTypeAction) => {
      state.eventType = action.payload.eventType;
    },
    setNotificationTypes: (
      state,
      action: NotificationsSetNotificationTypesAction
    ) => {
      state.notificationTypes = action.payload.notificationTypes;
    },
    setSelectedIds: (state, action: NotificationsSetSelectedIdsAction) => {
      state.selectedIds = action.payload.ids;
    },
    setIsLoading: (state, action: NotificationsSetIsLoadingAction) => {
      state.isLoading = action.payload.isLoading;
    },
    reset: (state) => {
      state.isReady = initialState.isReady;
      state.unreadMessages = initialState.unreadMessages;
      state.eventType = initialState.eventType;
      state.selectedIds = initialState.selectedIds;
    },
    setBusinessUnitsSelectOptions: (
      state,
      { payload }: PayloadAction<ISelectOption[]>
    ) => {
      state.userBusinessUnits = payload;
    },
    setBUFilterValue: (state, { payload }: PayloadAction<ISelectOption[]>) => {
      state.buFilterValue = payload.map(({ value }) => Number(value));
    },
    setIsBuFilterDisabled: (state, { payload }: PayloadAction<boolean>) => {
      state.isBUFilterDisabled = payload;
    },
  },
});

export const NOTIFICATIONS_START_INIT = `${STORE_NAME}/startInit`;
export const NOTIFICATIONS_REFRESH = `${STORE_NAME}/refresh`;
export const NOTIFICATIONS_MARK_AS_READ = `${STORE_NAME}/markAsRead`;
export const NOTIFICATIONS_DELETE = `${STORE_NAME}/delete`;
export const NOTIFICATIONS_NEW_RECEIVED = `${STORE_NAME}/newReceived`;

export const notificationsActions = {
  ...NotificationsStore.actions,
  startInit: createAction(NOTIFICATIONS_START_INIT),
  refresh: createAction(NOTIFICATIONS_REFRESH),
  markAsRead: createAction<INotificationsMarkAsReadActionPayload>(
    NOTIFICATIONS_MARK_AS_READ
  ),
  delete: createAction<INotificationsDeleteActionPayload>(NOTIFICATIONS_DELETE),
  newReceived: createAction<INotificationsNewReceivedActionPayload>(
    NOTIFICATIONS_NEW_RECEIVED
  ),
};

export const notificationsReducer = NotificationsStore.reducer;
